function toggle() {
  return {
    isOpen: false,
    get isClosed() {
      return !this.isOpen;
    },
    toggle() {
      if (this.isOpen) {
        return this.close();
      }

      this.open();
    },
    open() {
      this.isOpen = true;
    },
    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
    },
  };
}

export default toggle;
